import { dashboardPreferencesAtom } from "@/core/state";
import { DIRECTIONS } from "@payping/utilities-shared/consts";
import { useAtom } from "jotai";
import { selectAtom } from "jotai/utils";

const directionAtom = selectAtom(dashboardPreferencesAtom, (val) => val.direction);

/** Ant Drawer component uses absolute positioning so when we change our application's direction the placement of Drawers won't change on its own */
export const useDrawerPlacement = () => {
  const [direction] = useAtom(directionAtom);

  return direction === DIRECTIONS.LTR ? "right" : "left";
};
